var map = {
	"./B-C.png": 8872,
	"./C-10.png": 1339,
	"./C-2.png": 6371,
	"./C-3.png": 8957,
	"./C-4.png": 9537,
	"./C-5.png": 9369,
	"./C-6.png": 7829,
	"./C-7.png": 5095,
	"./C-8.png": 1181,
	"./C-9.png": 3973,
	"./C-A.png": 7057,
	"./C-J.png": 7189,
	"./C-K.png": 8786,
	"./C-Q.png": 8858,
	"./D-10.png": 5183,
	"./D-2.png": 9506,
	"./D-3.png": 3033,
	"./D-4.png": 9214,
	"./D-5.png": 8445,
	"./D-6.png": 4027,
	"./D-7.png": 6515,
	"./D-8.png": 7374,
	"./D-9.png": 1013,
	"./D-A.png": 8098,
	"./D-J.png": 7228,
	"./D-K.png": 6448,
	"./D-Q.png": 4459,
	"./H-10.png": 5686,
	"./H-2.png": 1357,
	"./H-3.png": 6954,
	"./H-4.png": 6411,
	"./H-5.png": 687,
	"./H-6.png": 584,
	"./H-7.png": 674,
	"./H-8.png": 7219,
	"./H-9.png": 4851,
	"./H-A.png": 320,
	"./H-J.png": 6073,
	"./H-K.png": 8292,
	"./H-Q.png": 8929,
	"./J-B.png": 530,
	"./J-R.png": 6992,
	"./S-10.png": 9494,
	"./S-2.png": 2629,
	"./S-3.png": 3652,
	"./S-4.png": 1718,
	"./S-5.png": 2766,
	"./S-6.png": 8614,
	"./S-7.png": 7848,
	"./S-8.png": 8667,
	"./S-9.png": 9896,
	"./S-A.png": 4367,
	"./S-J.png": 1956,
	"./S-K.png": 3173,
	"./S-Q.png": 5577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;